import {Provider} from '@angular/core';
import {ClientHttpProvider} from '@shared/infrastructure/http/client.http.provider';
import {LocalStorageAdapterProvider} from '@shared/infrastructure/storage/local/local.storage.adapter.provider';

import {
  GetUsuryRateHttpAdapter
} from '@features/setting/infrastructure/http/get-usury-rate/get-usury-rate.http.adapter';
import {NavigationAdapterProvider} from '@shared/infrastructure/navigation/navigation.adapter.provider';
import {
  GetUsuryRateUseCasePort
} from '@features/setting/application/use_cases/get-usury-rate/get-usury-rate.use-case.port';

export const GetUsuryRateHttpProvider: Provider[] = [
  ClientHttpProvider,
  LocalStorageAdapterProvider,
  NavigationAdapterProvider,
  {
    provide: GetUsuryRateUseCasePort,
    useClass: GetUsuryRateHttpAdapter
  }
];
